import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import {fetchArticleCategoriesActionTypes, ISitemapArticleCategory} from "../actions/fetch_site_map_article_category";
import {fetchSiteMapOfferListActionTypes, ISitemapOfferListResponse} from "../actions/fetch_site_map_offer";
import {fetchSiteMapVendorListActionTypes, ISitemapVendorListVendor} from "../actions/fetch_site_map_vendor_list";
import {ISiteMapArticleStore, siteMapArticleReducer} from "./site_map_articles_reducer";
import {ISitemapRegionsStore, siteMapRegionsReducer} from "./site_map_regions_reducer";

export interface ISiteMapStore {
    regions: ISitemapRegionsStore;
    offers: ISitemapOfferListResponse | null;
    articleCategories: ISitemapArticleCategory[] | null;
    articles: ISiteMapArticleStore;
    vendors: ISitemapVendorListVendor[] | null;
}

export const siteMapReducer = combineReducers({
    regions: siteMapRegionsReducer,
    offers: reduceResponse<ISitemapOfferListResponse>(fetchSiteMapOfferListActionTypes),
    articleCategories: reduceResponse<ISitemapArticleCategory[]>(fetchArticleCategoriesActionTypes),
    articles: siteMapArticleReducer,
    vendors: reduceResponse<ISitemapVendorListVendor[]>(fetchSiteMapVendorListActionTypes)
});
